import { StudyEntityType, VeevaCaseReportFormMappingOrder } from '@faro/study-designer-model';
import { createStudyEntityHookFactory } from '../createStudyEntityHookFactory';
import { veevaCaseReportFormMappingOrderClient } from './VeevaCaseReportFormMappingOrderClient';

const factory = createStudyEntityHookFactory<VeevaCaseReportFormMappingOrder>(StudyEntityType.VeevaFormMappingOrder);

export const useVeevaCaseReportFormMappingOrder = factory.list(veevaCaseReportFormMappingOrderClient.list);
